<template>
  <div class="dataWrapper">

    <header>
      <!-- 面包屑 -->
      <a-breadcrumb>
        <a-breadcrumb-item>
          <router-link to="/compareData">数据对比</router-link>
        </a-breadcrumb-item>
        <a-breadcrumb-item>
          <router-link :to="{path:'compareData'}">{{MenuName}}</router-link>
          <!-- <router-link :to="{path:'compareData',query:{pageName:this.pageName}}">{{MenuName}}</router-link> -->
        </a-breadcrumb-item>

        <a-breadcrumb-item>数据页</a-breadcrumb-item>
      </a-breadcrumb>
      <h2 class="dataHeadTitle">{{sbJson.name}}</h2>
    </header>

    <section>
      <GetTable :sbJson="sbJson" />
    </section>

  </div>
</template>

<script>
import GetTable from '@/components/dataCompare/children/compareTable2.vue'
import Com from '@/common/js/com.js'
export default {
  data () {
    return {
      pageName: '',
      MenuName: ''
    }
  },
  created () {
    const pageName = window.sessionStorage.getItem('pageName')
    this.pageName = pageName
    this.MenuName = Com.getMenuName(pageName)
  },
  computed: {
    sbJson: function () {
      return JSON.parse(this.$route.query.param)
    }
  },
  components: {
    GetTable
    // SlotV
  }
}
</script>

<style lang='less' scoped>
.dataWrapper {
  height: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;

  header {
    // flex: 0 0 0.98rem;
    height: 0.98rem;
    padding: 0.16rem 0.32rem;
    background-color: #fff;

    .dataHeadTitle {
      font-size: 0.2rem;
      color: rgba(0, 0, 0, 0.85);
      padding-top: 0.16rem;
      margin: 0;
      font-weight: bold;
    }
  }

  section {
    // flex: 1;
    height: calc(100% - 0.98rem);
    padding: 0.14rem 0.24rem;
    overflow: auto;
  }
}
</style>
